<template>
    <div class="m-0 p-0 border">
        <b-modal :title="title" size="huge" id="2" class="p-0 m-0 modal-huge clearfix" v-model="dialogOpen"
                 @hidden="onDialogHidden"
                 @shown="onDialogShown"
                 ok-only ok-variant="secondary" ok-title="Close">

            <template #modal-header="">
                <div class="float-left">
                    <h5 class="mb-0 pb-0">{{ title }} [{{ totalRows }}]</h5>
                    <span v-if="!assignmentMode && timeZoneId != null" class="m-0 p-0"><strong>Time Zone:</strong> {{ timeZoneId }} </span>
                    <span class="m-0 mr-1 p-0"><strong>Date:</strong> {{ formatDateTime(relevantDate, 'DD-MMM-YYYY') }}</span>
                    <span class="m-0 p-0" v-if="assignmentMode && relevantStartTime != null && relevantEndTime != null">
                        <strong>Start time:</strong> {{ formatDateTime(relevantStartTime, 'HH:mm') }}
                        <strong>End time:</strong> {{ formatDateTime(relevantEndTime, 'HH:mm')}}
                    </span>
                    <template v-if="turnAllocationMode">
                        <br />
                        <span class="m-0 p-0 ">Turn allocation mode: {{ getAssignmentModeDisplayString }}</span>
                    </template>
                </div>
                <div class="float-right" v-if="!showConfirmationPanel">
                    <b-form-checkbox-group v-model="filterIncludeRoles"
                                           :options="filterRoleOptions">
                    </b-form-checkbox-group>
                    <b-form-checkbox size="sm" v-model="includeUnavailableStaff" @change="loadAvailableStaff()" class="float-left">include unavailable staff</b-form-checkbox>
                </div>
            </template>

            <div v-if="!showConfirmationPanel" class="ml-3">

                <b-row class="w-100">
                    <b-col class="m-0 p-0" cols="6" v-if="!assignmentMode">
                        <div class="float-left ml-3 mr-2"><strong>Employment Type:</strong> {{ employmentType!=null ? employmentType : 'all' }}</div>
                        <div class="float-left mr-2"><strong>Skill Level:</strong> {{ skillLevel!=null ? skillLevel : 'all' }}</div><br />
                        <div class="float-left ml-3"><strong>Registry/Organisation:</strong> {{ entityDisplayString }}</div>
                    </b-col>
                    <b-col cols="6" v-else>
                        <div class="float-left">
                            <b-form-input size="sm" v-model="nameFilter" placeholder="Name filter" class="float-left" style="width: 200px;"></b-form-input>
                            <b-form-checkbox size="sm" v-model="filterNoAssignedJobsOnly" class="float-left ml-2">Only show staff with no Jobs assigned</b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col cols="2" class="m-0 pb-1"><b-button @click="setPosition('left')" size="sm" class="w-100" :variant="position=='left' ? 'warning' : 'outline-warning'">Earlier (00:00-12:00)</b-button></b-col>
                    <b-col cols="2" class="m-0 pb-1"><b-button @click="setPosition('center')" size="sm" class="w-100" :variant="position=='center' ? 'warning' : 'outline-warning'">Business hours</b-button></b-col>
                    <b-col cols="2" class="m-0 pb-1"><b-button @click="setPosition('right')" size="sm" class="w-100" :variant="position=='right' ? 'warning' : 'outline-warning'">Later (12:00-24:00)</b-button></b-col>
                </b-row>

                <div class="w-50 float-left">

                    <b-row class="smaller">

                        <b-col cols="1" class="border ml-3 p-0 pl-1 text-center border-secondary col-fontsize" v-bind:class="columnToSort=='securityClearance' ? 'font-weight-bold' : 'font-weight-normal'">
                            <b-link href="#" @click="sortStaffList('securityClearance');">Clear</b-link>
                            <b-icon v-if="columnToSort=='securityClearance'" :icon="sortDirection=='ascending' ? 'arrow-up' : 'arrow-down'" class="arrow-style" />
                        </b-col>

                        <b-col class="border p-0 pl-1 border-secondary col-fontsize" v-bind:class="columnToSort=='staffName' ? 'font-weight-bold' : 'font-weight-normal'">
                            <b-link href="#" @click="sortStaffList('staffName');">Staff Name</b-link>
                            <b-icon v-if="columnToSort=='staffName'" :icon="sortDirection=='ascending' ? 'arrow-up' : 'arrow-down'" class="arrow-style" />
                        </b-col>

                        <b-col cols="2" class="border p-0 pl-1 text-center m-0 border-secondary col-fontsize">
                            Status
                        </b-col>

                        <b-col cols="1" class="border p-0 pl-1 text-center m-0 border-secondary col-fontsize" v-bind:class="columnToSort=='skillLevel' ? 'font-weight-bold' : 'font-weight-normal'">
                            <b-link href="#" @click="sortStaffList('skillLevel');">Skill</b-link>
                            <b-icon v-if="columnToSort=='skillLevel'" :icon="sortDirection=='ascending' ? 'arrow-up' : 'arrow-down'" class="arrow-style" />
                        </b-col>

                        <b-col cols="3" class="border border-secondary mr-3 col-fontsize text-center">Roles</b-col>

                    </b-row>

                    <b-row class="mb-1 smaller" align-v="center" v-for="(staffMember,staffMemberIndex) in filteredAvailableStaff" style="height:30px;" v-bind:key="staffMemberIndex">

                        <b-col cols="1" class="ml-3 border col-fontsize text-center p-1">
                            <div v-b-tooltip.hover="staffMember.securityClearanceDisplayName">{{ abreviateSecurityClearanceDispalyName(staffMember.securityClearanceDisplayName) }}</div>
                        </b-col>
                        <b-col class="border col-fontsize p-1" :id="`popover-1-${staffMemberIndex}`">

                            <b-form-checkbox v-if="assignmentMode"
                                             :checked="staffSelected(staffMember.userAccountId)"
                                             @change="checked => staffSelectedChanged(staffMember.userAccountId, checked)"
                                             :disabled="!canUnassign(staffMember.userAccountId)"
                                             size="md"
                                             class="float-left"></b-form-checkbox>

                            {{ staffMember.givenNames }}<strong> {{ staffMember.lastName }}</strong> [<b-link :href="$urlHelper.getPageUrl('WorkItems', [ staffMember.userAccountId, 'User' ])" target="blank">{{ staffMember.assignedJobs }}</b-link>][{{ staffMember.employmentTypeDisplayName.substring(0,4) }}]
                        </b-col>

                        <b-col cols="2" :class="'border text-center col-fontsize text-' + getStaffStatusVariant(staffMember.userAccountId) + ' p-1'">
                            <template v-if="getStaffStatus(staffMember.userAccountId)">
                                {{  getStaffStatus(staffMember.userAccountId) }}
                            </template>
                            <template v-else>
                                &nbsp;
                            </template>
                        </b-col>

                        <b-col cols="1" class="border col-fontsize text-center p-1">
                            <img :src="getSkillLevelImageUrl(staffMember.skillLevel)" :alt="staffMember.skillLevelDisplayName" :title="staffMember.skillLevelDisplayName" height="19" />
                        </b-col>

                        <b-col cols="3" class="border mr-3 text-center pt-1">
                            <template v-for="role in staffMember.roles">
                                <img class="mt-1 mb-1" :src="getRoleImageUrl(role.roleId)" :alt="role.roleDisplayName" :title="role.roleDisplayName" width="17" :key="role.roleId" v-if="isRoleRelevant(role.roleId)" />
                            </template>
                        </b-col>

                        <b-popover :target="`popover-1-${staffMemberIndex}`"
                                   placement="right"
                                   :title="'Profile: ' + staffMember.givenNames + ' ' + staffMember.lastName"
                                   triggers="hover"
                                   custom-class="wide-popover"
                                   variant="dark">

                            <b-card custom-class="w-50">
                                <b-card-text>
                                    <b-container class="bv-example-row">
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Email:</b-col>
                                            <b-col>{{ staffMember.email }}</b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Name:</b-col>
                                            <b-col>{{ staffMember.givenNames }} {{ staffMember.lastName }}</b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Employment Type:</b-col>
                                            <b-col>{{ staffMember.employmentTypeDisplayName }}</b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Skill level:</b-col>
                                            <b-col>{{ staffMember.skillLevelDisplayName }}</b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Security Clearance:</b-col>
                                            <b-col>{{ staffMember.securityClearanceDisplayName }}</b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Roles:</b-col>
                                            <b-col>
                                                <div v-html="createRoleDisplayString(staffMember.roles)"></div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Assigned Jobs:</b-col>
                                            <b-col>{{ staffMember.assignedJobs }}</b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Options:</b-col>
                                            <b-col>
                                                <div v-html="createOptionsDisplayString(staffMember)"></div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4" class="font-weight-bold">Comments:</b-col>
                                            <b-col>{{ staffMember.comments }}</b-col>
                                        </b-row>
                                    </b-container>
                                </b-card-text>
                            </b-card>
                        </b-popover>
                    </b-row>
                </div>

                <div class="w-50 float-right">
                    <div style="font-size:15px;" v-bind:class="assignmentMode ? 'assignment-mode' : 'non-assignment-mode'">
                        <b-col cols="1" v-bind:class="getRelevantTimePart == hour ? matching-hour : ''" class="border border-secondary text-center float-left p-0 m-0" v-for="(hourValue, hour) in hoursDisplayed" :key="hour">{{ hourValue }}:00</b-col>
                    </div>
                    <div v-for="(staffMember,staffMemberIndex) in filteredAvailableStaff" v-bind:key="staffMemberIndex">
                        <b-progress class="mb-1 float-left" style="height:30px;" v-bind:class="assignmentMode ? 'assignment-mode' : 'non-assignment-mode'">
                            <b-progress-bar :value="timeSlot.timeSlotDurationMinutes" v-bind:class="timeSlot.selected ? availableClass : notAvailableClass" show-progress v-for="(timeSlot,timeSlotIndex) in shiftTimeSlots(staffMember.timeSlots)" :key="timeSlotIndex" :label="timeSlot.timeSlotDurationMinutes <= 60 ? ' ' : timeSlot.timeSlotDisplayText "></b-progress-bar>
                        </b-progress>

                    </div>
                </div>
            </div> <!-- end panel 1-->

            <assignment-confirmation-panel v-if="showConfirmationPanel"
                                           :work-item-id="workItemId"
                                           :round-robin-mode="roundRobinMode"
                                           :newly-selected-staff-user-accounts="newlySelectedStaffUserAccounts"
                                           :newly-unselected-staff-user-accounts="newlyUnselectedStaffUserAccounts"
                                           :initial-current-selected-staff-user-accounts="currentSelectedStaffUserAccounts"
                                           :current-user-account-id="currentUserAccountId"
                                           :available-staff="availableStaff"
                                           :isDelayedAssignment="false"
                                           :default-response-time="defaultResponseTime"
                                           :all-default-response-time-options="allDefaultResponseTimeOptions"
                                           :api-assignment-controller-url="apiAssignmentControllerUrl"
                                           :roles-with-audio-minutes="rolesWithAudioMinutes"
                                           :roles-with-round-robin-priority="rolesWithRoundRobinPriority"
                                           @hideConfirmationPanel="showConfirmationPanel=false"
                                           @assignmentChanged="assignmentChanged()"
                                           :turn-allocation-mode="turnAllocationMode">
            </assignment-confirmation-panel>

            <template #modal-footer>
                <div class="w-100 mb-2 p-0">
                    <b-pagination v-model="currentPage" v-if="!showConfirmationPanel"
                                  :total-rows="totalRows"
                                  :per-page="perPage"
                                  aria-controls="my-table"
                                  class="float-left m-0 p-0"></b-pagination>

                    <div v-if="!showConfirmationPanel">
                        <b-select v-model="perPage" :options="pageSizes" class=" ml-2 float-left w-auto" />
                        <b-badge class="ml-2 mt-2 p-2" variant="primary">Total available staff: {{ totalRows }}</b-badge>

                        <b-button @click="showConfirmationPanel=true" class="float-right m-0" variant="success" v-if="assignmentMode">Assignment Details</b-button>
                        <b-button @click="selectAllStaffOnPage" variant="warning" class="float-right mr-1" v-if="assignmentMode">Select/deselect all</b-button>
                        <b-button @click="dialogOpen=false;" variant="secondary" class="float-right mr-1">Close</b-button>
                    </div>

                </div>
            </template>
        </b-modal>

        <div class="d-flex justify-content-center">
            <b-spinner variant="secondary" label="Loading..." v-if="showSpinner"></b-spinner>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    
    import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import UserMixin from '../../mixins/UserMixin';
    
    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);

    export default {
        name: 'AvailabilityDayAccumulated',
        mixins: [ErrorsMixin, DateTimeMixin, UserMixin],
        model: {
            event: 'change',
            prop: 'active',
        },
        components: {
        },
        props: {
            workItemId: {
                type: String,
                required: false,
                default: null
            },
            currentUserAccountId: {
                type: String,
                required: false
            },
            // availability controller URL
            apiControllerUrl: { 
                type: String,
                required: true
            },
            apiAssignmentControllerUrl: {
                type: String,
                required: true
            },
            imagesUrl: {
                type: String,
                required: true
            },
            title: {
                type: String,
                default: 'no title'
            },
            relevantRoles: {
                type: Array,
                required: true
            },
            rolesWithAudioMinutes: {
                type: Array,
                required: true
            },
            rolesWithRoundRobinPriority: {
                type: Array,
                required: true
            },
            checkedRoles: {
                type: Array,
                default: null
            },
            relevantDate: {
                type: Date,
                required: false,
                default: function () { // FRAGE
                    return new Date()
                },
            },
            relevantStartTime: {
                type: Date,
                required: false,
                default: null
            },
            relevantEndTime: {
                type: Date,
                required: false,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            // filter related stuff start
            timeRangeFilter: {
                type: String,
                required: false,
                default: null
            },
            employmentType: {
                type: String,
                required: false,
                default: null
            },
            skillLevel: {
                type: String,
                required: false,
                default: null
            },
            courtRegistryId: {
                type: String,
                required: false,
                default: null
            },
            interviewOrganisationId: {
                type: String,
                default: null
            },
            entityDisplayString: {
                type: String,
                required: false,
                default: null
            },
            timeZoneId: {
                type: String,
                required: false,
                default: null
            },
            // filter related stuff end
            assignmentMode: {
                type: Boolean,
                required: true
            },
            roundRobinMode: {
                type: Boolean,
                default: true
            },
            defaultResponseTime: {
                type: Number,
                default: 6
            },
            allDefaultResponseTimeOptions: {
                type: Array,
                default: null
            },
            turnAllocationMode: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                isHovered: false,
                showSpinner: false,
                dialogOpen: this.active,
                showCard: false,
                visibleStartTime: 6,
                visibleEndTime: 18,
                availableStaff: null,
                position: 'center',
                availableClass: 'available',
                notAvailableClass: 'not-available',
                filterIncludeRoles: Array.from(this.relevantRoles, role => role.roleId), //this will "convert" the array of objects into an array of role IDs
                // paging vars
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
                pageSizes: [5, 10, 25, 50],
                columnToSort: 'staffName',
                sortDirection: 'ascending',
                nameFilter: '',
                filterNoAssignedJobsOnly: false,
                currentSelectedStaff: null,

                selectedStaff: [],
                currentSelectedStaffUserAccounts: [],
                includeUnavailableStaff: false,
                showConfirmationPanel: false,

                comment: null,
                responseTime: this.defaultResponseTime,
                responseTimeOptions: this.allDefaultResponseTimeOptions,
                responseDueByDateTimeUTC: null
            }
        },

        watch: {
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    if (this.assignmentMode) {
                        this.loadSelectedStaff()
                            .then(() => {
                                this.loadAvailableStaff(true);
                            });
                    } else {
                        this.loadAvailableStaff(true);
                    }
                } else {
                    this.filterIncludeRoles = Array.from(this.relevantRoles, role => role.roleId);
                    this.columnToSort = 'staffName';
                    this.sortDirection = 'ascending';
                    this.nameFilter = '';
                    this.filterNoAssignedJobsOnly = false;
                    this.includeUnavailableStaff = false;
                }
            },
            checkedRoles: function () {
                if (this.checkedRoles != null) {
                    this.filterIncludeRoles = this.checkedRoles;
                } else {
                    this.filterIncludeRoles = Array.from(this.relevantRoles, role => role.roleId);
                }
            }
        },

        computed: {

            hoursDisplayed: function () {
                var myArray = [];
                for (var i = this.visibleStartTime; i < this.visibleEndTime; i++) {
                    myArray.push(i);
                }
                return myArray;
            },

            filterRoleOptions: function () {
                var roles = [];
                this.relevantRoles.forEach((role) => {
                    roles.push({ value: role.roleId, text: role.roleDisplayName });
                });
                return roles;
            },

            filteredAvailableStaff: function () {

                var filteredStaffList = [];
                if (this.availableStaff && this.availableStaff.length) {
                    // to make sure that THIS referes to the component inside the forEach
                    var thisComponent = this;    
                    this.availableStaff.forEach(function (staffMember) {

                        var include = false;
                        var assignedRoles = staffMember.roles;

                        for (var i = 0; i < assignedRoles.length; i++) {
                            var roleId = assignedRoles[i].roleId;
                            if (thisComponent.filterIncludeRoles && (thisComponent.filterIncludeRoles.indexOf(roleId) >= 0)) include = true;
                        }
                        if (include && thisComponent.filterNoAssignedJobsOnly) {
                            if (staffMember.assignedJobs > 0) include = false;
                        }

                        var nameInclude = true;
                        if (thisComponent.nameFilter != '') {
                            if (staffMember.givenNames.toLowerCase().indexOf(thisComponent.nameFilter.toLowerCase()) < 0 &&
                                staffMember.lastName.toLowerCase().indexOf(thisComponent.nameFilter.toLowerCase()) < 0) { nameInclude = false; }
                        }

                        if (include && nameInclude) { filteredStaffList.push(staffMember); }
                    });
                }

                // setting the total number of Filterd rows (checkboxes!) before we slice for paging
                this.setTotalRowsForDisplay(filteredStaffList.length);
                // slicing the filtered result for paging
                return filteredStaffList.slice((this.currentPage - 1) * this.perPage, (this.currentPage - 1) * this.perPage + this.perPage);
            },

            newlySelectedStaffUserAccounts: function () {
                
                if (this.currentSelectedStaffUserAccounts == null) return null;
                var userAccounts = [];
                this.currentSelectedStaffUserAccounts.forEach(userAccount => {

                    if (!this.selectedStaff.find(e => e.userAccountId === userAccount.userAccountId && e.selected)) {
                        userAccounts.push(userAccount);
                    }
                });
                if (userAccounts.length == 0) return null;
                return userAccounts;
            },

            newlyUnselectedStaffUserAccounts: function () {
                if (this.selectedStaff == null) return null;
                var userAccounts = [];
                this.selectedStaff.forEach(userAccount => {
                    var accountToBeRemoved = this.currentSelectedStaffUserAccounts.find((e => e.userAccountId === userAccount.userAccountId));
                    if (userAccount.selected && ((!this.currentSelectedStaffUserAccounts) || (typeof accountToBeRemoved == 'undefined'))) {
                        userAccounts.push({ userAccountId: userAccount.userAccountId, roundRobinPriority: null, 'selectedRoles': userAccount.roles });
                    }
                });
                if (userAccounts.length == 0) return null;
                return userAccounts;
            },
            getAssignmentModeDisplayString: function () {

                if (this.turnAllocationMode === this.$enum.TurnAllocationMode.FirstComeFirstServe) return 'First come first serve';
                if (this.turnAllocationMode === this.$enum.TurnAllocationMode.RoundRobin) return 'Round robin';
                if (this.turnAllocationMode === this.$enum.TurnAllocationMode.AssignedAudioLength) return 'Assigned audio length';
                return '';
            }
        }, // computed

        methods: {
            canUnassign: function (userAccountId) {
                var userObj = this.selectedStaff.find(e => e.userAccountId === userAccountId);
                if (userObj) return userObj.canUnassign
                else return true;
            },

            assignmentChanged: function () {
                this.$emit('assignmentChanged');
                this.showConfirmationPanel = false;
                this.dialogOpen = false;
            },

            getStaffName: function (userAccountId) {
                var staff = this.availableStaff.find(e => e.userAccountId == userAccountId);
                if (staff) return staff.givenNames + ' ' + staff.lastName;
                else { return 'You will be auto assigned to this worksheet!'; }
            },

            getStaffEmail: function (userAccountId) {
                var staff = this.availableStaff.find(e => e.userAccountId == userAccountId);
                if (staff) return staff.email;
                else { return '- no email present -'; }
            },

            // THIS ONE IS doubled up in the AssignmentConfirmationPanel.vue
            roundRobinPriority: function (index) {
                var currentUserIndex = this.currentSelectedStaffUserAccounts.findIndex(e => e.userAccountId == this.currentUserAccountId);
                if (currentUserIndex >= 0 && index == currentUserIndex) return null;
                if (currentUserIndex >= 0 && index > currentUserIndex) return index;
                return index + 1;
            },
            
            getRelevantTimePart: function (hour) {
                if (this.relevantDate.getDate() != hour) return 'matching-hour';
                else return false;
            },

            selectAllStaffOnPage: function () {
              
                var allStaffOnPageSelected = true;
                var userObj = null;
                for (var j = 0; j < this.filteredAvailableStaff.length; j++) {
                    userObj = this.currentSelectedStaffUserAccounts.find(f => f.userAccountId == this.filteredAvailableStaff[j].userAccountId);
                    if (typeof userObj == 'undefined') {
                        allStaffOnPageSelected = false;
                    }
                }

                if (!allStaffOnPageSelected) {

                    for (var i = 0; i < this.filteredAvailableStaff.length; i++) {
                        this.staffSelectedChanged(this.filteredAvailableStaff[i].userAccountId, true);
                    }
                } else {
                    var staffAccounts = [];
                    this.currentSelectedStaffUserAccounts.forEach(staff => {
                        if (!staff.canUnassign) staffAccounts.push(staff);
                    })
                    this.currentSelectedStaffUserAccounts = staffAccounts;
                }
            },

            abreviateSecurityClearanceDispalyName: function (securityDisplayName) {
                var wordArray = securityDisplayName.split(" ");
                var abreviatedDisplayString = '';
      
                for (var i = 0; i < wordArray.length; i++) {
                    abreviatedDisplayString += wordArray[i].charAt(0)
                }
                return abreviatedDisplayString;
            },

            getStaffStatus: function (userAccountId) {
                var selectedStaff = this.selectedStaff.find(e => e.userAccountId == userAccountId);
                if (selectedStaff) return selectedStaff.statusDisplayName;
                return null;
            },
            getStaffStatusVariant: function (userAccountId) {
                var selectedStaff = this.selectedStaff.find(e => e.userAccountId == userAccountId);
                if (selectedStaff) return selectedStaff.statusVariant;
                return 'black';
            },
            staffSelected: function (userAccountId) {
                var userObj = this.currentSelectedStaffUserAccounts.find(e => e.userAccountId == userAccountId);
                return (typeof userObj !== 'undefined');
            },

            staffSelectedChanged: function (userAccountId, selected) {
               
                var userObj = {};
                if (selected) {

                    if (this.currentSelectedStaffUserAccounts == null) {
                        this.currentSelectedStaffUserAccounts = [];
                    }

                    if (this.currentSelectedStaffUserAccounts.findIndex(e => e.userAccountId == userAccountId) < 0) {

                        userObj.userAccountId = userAccountId;
                        userObj.audioMinutes = null;
                        userObj.canUnassign = true;
                        userObj.canChangeAssignedMinutes = true;
                        userObj.minAssignedAudioMinutes = null;
                        userObj.requiredRoles = null;

                        // the role business
                        var staff = this.availableStaff.find(e => e.userAccountId == userAccountId);
                        var roleArray = [];
                        staff.roles.forEach(role => {
                            roleArray.push(role.roleId);
                        })
                        userObj.selectedRoles = roleArray;

                        this.currentSelectedStaffUserAccounts.push(userObj);
                    }

                } else if (this.currentSelectedStaffUserAccounts != null) {

                    var userObjectIndex = this.currentSelectedStaffUserAccounts.findIndex(e => e.userAccountId == userAccountId);
                    if (userObjectIndex >= 0) {
                        this.currentSelectedStaffUserAccounts.splice(userObjectIndex, 1);
                    }
                }
            },
            
            loadSelectedStaff: function () {
            
                this.currentErrors = [];
                var url = this.apiAssignmentControllerUrl;
                if (!url.endsWith('/')) url += '/';

                url += 'usersbyworkitem/';
                url += this.workItemId;
                return axios
                    .get(url)
                    .then(response => {
                        this.selectedStaff = response.data.users;
                        this.currentSelectedStaffUserAccounts = [];
               
                        if (this.selectedStaff) {
                            this.selectedStaff.forEach(e => {
                                if (e.selected || e.proposed) this.currentSelectedStaffUserAccounts.push({
                                    userAccountId: e.userAccountId,
                                    roundRobinPriority: e.roundRobinPriority,
                                    selectedRoles: e.roles,
                                    requiredRoles: e.requiredRoles,
                                    canUnassign: e.canUnassign,
                                    canChangeAssignedMinutes: e.canChangeAssignedMinutes,
                                    minAssignedAudioMinutes: e.minAssignedAudioMinutes
                                });
                            });
                        }
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            sortStaffList: function (columnToSort) {
                this.columnToSort = columnToSort;
                if (this.sortDirection == 'ascending') {
                    this.sortDirection = 'descending';
                } else { this.sortDirection = 'ascending'; }

                this.loadAvailableStaff();
            },

            isRoleRelevant(roleId) {
                return this.relevantRoles.find(role => role.roleId == roleId);
            },

            setTotalRowsForDisplay: function (numberOfFilteredRows) {
                this.totalRows = numberOfFilteredRows;
            },
            createRoleDisplayString: function (roleArray) {
                var roleDisplayString = '';
                for (var i = 0; i < roleArray.length; i++) {
                    roleDisplayString += roleArray[i].roleDisplayName + ', ';
                }
                return roleDisplayString;
            },
            createOptionsDisplayString: function (staffMember) {
                var optionsDisplayString = '';
                if (staffMember.availableForRealTime) optionsDisplayString = 'TVL';
                if (staffMember.availableForOnSite) optionsDisplayString += ' O/S';
                if (staffMember.availableForTravel) optionsDisplayString += ' RT';
                return optionsDisplayString;
            },

            shiftTimeSlots: function (timeSlots) {

                // when button is pressed: store visibleStartTime, visibleEndTime which is in turn used here.
                var newTimeSlots = []; // use new slot objects !! dont change original data
                var accumulatedTimeSlotDurations = 0;

                for (var i = 0; i < timeSlots.length; i++) {

                    var newTimeSlot = {};
                    var timeSlotStart = accumulatedTimeSlotDurations;
                    var timeSlotEnd = accumulatedTimeSlotDurations + timeSlots[i].timeSlotDurationMinutes;

                    // time slot before visible starttime will be ignored
                    if ((timeSlotEnd) <= this.visibleStartTime * 60) {
                        accumulatedTimeSlotDurations += timeSlots[i].timeSlotDurationMinutes;
                        continue;
                    }
                    if (timeSlotStart >= (this.visibleEndTime * 60)) { break; }

                    if ((timeSlotStart < (this.visibleStartTime * 60)) && (timeSlotEnd > (this.visibleStartTime * 60))) {
                        // cutting off partial left
                        newTimeSlot.timeSlotDurationMinutes = timeSlotEnd - this.visibleStartTime * 60;
                        newTimeSlot.timeSlotStartDateTime = timeSlots[i].timeSlotStartDateTime;
                        newTimeSlot.timeSlotEndDateTime = timeSlots[i].timeSlotEndDateTime;
                        newTimeSlot.selected = timeSlots[i].selected;
                        newTimeSlot.timeSlotValue = timeSlots[i].timeSlotValue;
                        newTimeSlot.timeSlotStartDisplayText = timeSlots[i].timeSlotStartDisplayText;
                        newTimeSlot.timeSlotEndDisplayText = timeSlots[i].timeSlotEndDisplayText;
                        newTimeSlot.timeSlotDisplayText = timeSlots[i].timeSlotDisplayText;
                    }

                    if ((timeSlotStart < (this.visibleEndTime * 60)) && (timeSlotEnd > (this.visibleEndTime * 60))) {
                        // cutting off partial right
                        newTimeSlot.timeSlotDurationMinutes = this.visibleEndTime * 60 - timeSlotStart;
                        newTimeSlot.timeSlotStartDateTime = timeSlots[i].timeSlotStartDateTime;
                        newTimeSlot.timeSlotEndDateTime = timeSlots[i].timeSlotEndDateTime;
                        newTimeSlot.selected = timeSlots[i].selected;
                        newTimeSlot.timeSlotValue = timeSlots[i].timeSlotValue;
                        newTimeSlot.timeSlotStartDisplayText = timeSlots[i].timeSlotStartDisplayText;
                        newTimeSlot.timeSlotEndDisplayText = timeSlots[i].timeSlotEndDisplayText;
                        newTimeSlot.timeSlotDisplayText = timeSlots[i].timeSlotDisplayText;
                    }

                    // decide if we push original slot or new cut slot
                    if (Object.keys(newTimeSlot).length === 0) {
                        newTimeSlots.push(timeSlots[i]);
                    } else {
                        newTimeSlots.push(newTimeSlot)
                    }
                    accumulatedTimeSlotDurations += timeSlots[i].timeSlotDurationMinutes;
                }
                return newTimeSlots;
            },

            setPosition: function (position) {

                this.position = position;
                switch (position) {
                    case 'left':
                        this.visibleStartTime = 0;
                        this.visibleEndTime = 12;
                        break;
                    case 'center':
                        this.visibleStartTime = 6;
                        this.visibleEndTime = 18;
                        break;
                    case 'right':
                        this.visibleStartTime = 12;
                        this.visibleEndTime = 24;
                        break;
                    default:
                        this.visibleStartTime = 6;
                        this.visibleEndTime = 18;
                }
            },

            loadAvailableStaff: function (openDialog = false) {

                this.showSpinner = true;
                var requiredRoles = 0;
                this.relevantRoles.forEach(role => {
                    requiredRoles += role.roleId;
                });

                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';

                var filters = {
                    timeRange: 1, // this is default for giving back all 24 hours worth
                    typistSkillLevel: this.skillLevel,
                    employmentType: this.employmentType,
                    courtRegistryId: this.courtRegistryId,
                    interviewOrganisationId: this.interviewOrganisationId,
                    timezoneId: this.timeZoneId,
                    // default: sorted: [{ name: "staffName", direction: "descending" }],
                    sorted: [{ name: this.columnToSort, direction: this.sortDirection }],
                    requiredRoles: requiredRoles,
                    includeUnavailableStaff: this.includeUnavailableStaff,
                    workItemId: this.workItemId
                }
                if (this.currentSelectedStaffUserAccounts && this.currentSelectedStaffUserAccounts.length) {
                    filters.includeUserAccountIds = [];
                    this.currentSelectedStaffUserAccounts.forEach(e => {
                        filters.includeUserAccountIds.push(e.userAccountId);
                    });
                }

                url += 'stafflistforlivework/';
                url += this.formatDateTime(this.relevantDate, 'YYYY-MM-DD');
                axios
                    .post(url, JSON.stringify(filters),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        this.availableStaff = response.data;
                        //this.loadSelectedStaff();
                        this.showSpinner = false;
                        if (openDialog) this.dialogOpen = true;
                    })
                    .catch(ex => {
                        this.showSpinner = false;
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            getVariantColor: function (flag) {
                if (flag) return 'success'
                else return 'light';
            },
            onDialogShown: function () {
                this.$emit('modalOpen', true);
            },
            onDialogHidden: function () {
                this.$emit('change', false);
                this.$emit('modalOpen', false);
            }
        }, // methods

        mounted: function () {
            if (this.checkedRoles != null) {
                this.filterIncludeRoles = this.checkedRoles;
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 992px) {
        div >>> .modal .modal-huge {
            width: 95% !important;
            max-width: 1600px !important;
        }
    }
    div >>> .assignment-mode {
        width: 96%;
    }
    div >>> .non-assignment-mode {
        width: 100%;
    }
    div >>> .wide-popover {
        max-width: 700px !important;
        width: 700px !important;
    }
    div >>> .matching-hour {
        color: orangered;
    }
    div >>> .available {
        background-color: green !important;
    }
    div >>> .not-available {
        background-color: #aaa !important;
    }
    div >>> .col-fontsize {
        font-size: 15px;
    }
</style>
